export function lockScroll() {
  document.getElementsByTagName('body')[0].classList.add('lock-scroll');
};
export function unlockScroll() {
  document.getElementsByTagName('body')[0].classList.remove('lock-scroll');
};